import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileValidators } from 'ngx-file-drag-drop';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-projects-campaign-file-add',
  templateUrl: './projects-campaign-file-add.component.html',
  styleUrls: ['./projects-campaign-file-add.component.scss']
})
export class ProjectsCampaignFileAddComponent implements OnInit {

  dataSent : any;
  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([],[FileValidators.uniqueFileNames, FileValidators.maxFileCount(1)]);
  nombre : any = "";
  tipoPdf: number = 0;
  tipoImagen: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private main : MainService,
    private fb : FormBuilder,
    private projectsService : ProjectsService,
    private dialogRef: MatDialogRef<ProjectsCampaignFileAddComponent>,
  ) { 
    this.dataSent = this.data;
  }

  ngOnInit(): void {
    this.loadForm();
    this.preloadFormData();
  }

  preloadFormData(){
    this.bodyForm.append('folder', this.dataSent.folder as string);
    this.bodyForm.append('id_fase', this.dataSent.phase_id);
    this.bodyForm.append('id_proyecto', this.dataSent.diagram.id_proyecto);
    this.bodyForm.append('id_diagrama', this.dataSent.diagram.id);
    this.bodyForm.append('next_vobo_tipo', this.dataSent.next_vobo.tipo);
    this.bodyForm.append('next_vobo_users', this.dataSent.next_vobo.users.toString());
    this.bodyForm.append('vobo_id', this.dataSent.vobo_id);
    this.bodyForm.append('next_vobo', this.dataSent.next_vobo);
    this.bodyForm.append('phase', this.dataSent.phase);
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null, {validators:[Validators.required]}]
    });
  }
  onValueChange(files: any) { 
  let array_of_allowed_files = ['jpg', 'png', 'jpeg', 'pdf','mp4', 'mov', 'mkv', 'avi', 'webm', 'wmv', 'flv', 'mpeg', '3gp', 'ogg'];
  this.tipoPdf = 0;
  this.tipoImagen = 0;
  
  /* if (files.length > 1) {      
    files.splice(1, files.length - 1);
    Swal.fire({
      icon: 'warning',
      title: 'Error',
      html: 'Sólo puede adjuntarse un documento'
    });
  } */

  for (const item of files) {
    
    const extension = item.name.split('.').pop().toLowerCase();
    if (!array_of_allowed_files.includes(extension)) {
      const index = files.indexOf(item);

      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: `Solo se permiten archivos con las siguientes extensiones: ${array_of_allowed_files.join(', ')}`
      });

      if (index >= 0) {
        files.splice(index, 1);
      }
    }

    if(extension == 'jpg' || extension == 'png' || extension == 'jpeg'){
      this.tipoImagen++
    }
    if(extension == 'pdf'){
      this.tipoPdf++
    }

  }

  if(this.tipoPdf > 1){
    Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: `No se permite subir mas de un archivo pdf a la vez`
      });
      this.form.reset();
      this.fileControl.setValue(null);

  }
  if(this.tipoPdf >= 1 && this.tipoImagen >= 1){
    Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: `No se permite combinar archivos de tipo imagen y tipo pdf a la vez`
      });
      this.form.reset();
      this.fileControl.setValue(null);

  }

}

  uploadFile() {

    const files = this.form.value.blob;

    if (files && files != null) {

      //const bodyForm = new FormData();

      let i = 0;
      for (let file of files) {
        this.bodyForm.append(`blob${i}`, file);
        i++;
      }

      Swal.fire({
        icon: 'info',
        title: 'Subiendo archivos...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.projectsService.uploadCampaignProjectFile(this.bodyForm).subscribe(
        (result: any) => {
          if (result.message == 'Success') {
            Swal.fire({
              icon: 'success',
              title: 'Archivos subidos',
              text: 'Los archivos fueron subidos exitosamente'
            }).then(() => {
              this.dialogRef.close({ reload: true });
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar los archivos'
            });
          }
        },
        (err: any) => {
          if (err.error.message == "Invalid file") {
            Swal.fire({
              icon: 'warning',
              title: 'Error',
              html: 'Hay archivos con formato incorrecto'
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar'
            });
          }
        }
      );

    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        html: 'No se han adjuntado archivos'
      });
    }

  }

  

}
